import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

export default class ParityManagerFiltersMarketInfo extends Model {
  [Type] = 'parity-manager/filters/market-info' as const;

  @attr('string') declare name: string;

  get formattedName(): string {
    return this.name;
  }

  // Required to use as @options argument for (Combo)SelectInput component
  get label(): string {
    return this.formattedName;
  }
}
